import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_SALES_CS, ROLE_TECHNICAL } = ROLES;

const ALLOWED_ROLES_REQUEST_REFUND = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_SALES_CS, ROLE_TECHNICAL];

export function canRequestRefund(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_REQUEST_REFUND);
}

export function canViewRefunds(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_REQUEST_REFUND);
}
